document.addEventListener("DOMContentLoaded", function () {
    const filterContainer = document.querySelector(".game-performance-filter");
    const cpuValue = document.getElementById("cpu-value");
    const gpuValue = document.getElementById("gpu-value");
    const resolutionBtns = document.querySelectorAll(".resolution-btn");
    const loadingState = document.getElementById("loading-state");
    const noSelection = document.getElementById("no-selection");
    const noResults = document.getElementById("no-results");
    const productsGrid = document.getElementById("products-grid");
    const gameInfoBlock = document.getElementById("game-info-block");
    const gameInfoGrid = document.getElementById("game-info-grid");
    const resultsContainer = document.getElementById("results-container");

    // Track current rendered games
    let currentGames = [];

    // Get display mode from settings (data attribute)
    const displayMode = filterContainer?.dataset.displayMode || "products";

    // Get CPU and GPU from current product metafields
    let currentCPU = window.currentProduct?.cpu || null;
    let currentGPU = window.currentProduct?.gpu || null;

    // Get initial Resolution value from active button
    let currentResolution =
        document.querySelector(".resolution-btn.active")?.dataset.resolution ||
        "1080P";

    // Debounce timer
    let searchTimeout = null;

    // Setup initial display based on settings
    function initializeDisplay() {
        if (displayMode === "game-info") {
            // Show game info, hide products
            gameInfoBlock.style.display = "block";
            resultsContainer.style.display = "none";
        } else {
            // Show products, hide game info
            gameInfoBlock.style.display = "none";
            resultsContainer.style.display = "block";
        }
    }

    // Initialize display on load
    initializeDisplay();

    // Auto trigger search on page load (since we have default values selected)
    setTimeout(() => {
        console.log("Auto-trigger check:", {
            cpu: currentCPU,
            gpu: currentGPU,
            displayMode,
        });

        if (currentCPU && currentGPU) {
            if (displayMode === "products") {
                performSearch();
            } else if (displayMode === "game-info") {
                fetchGameFPS();
            }
        }
    }, 300);

    // Check if all filters are selected and trigger search
    function checkAndSearch() {
        // All required filters selected
        if (currentCPU && currentGPU) {
            // Debounce: wait 300ms before searching
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                if (displayMode === "products") {
                    performSearch();
                } else if (displayMode === "game-info") {
                    fetchGameFPS();
                }
            }, 300);
        } else if (displayMode === "game-info" && currentGames.length > 0) {
            // Reset FPS to "--" when filters not complete
            const resetGames = currentGames.map((g) => ({
                name: g.name,
                fps: "--",
            }));
            renderGameCards(resetGames, null, true);
        }
    }

    // Event listeners for resolution change only
    resolutionBtns.forEach((btn) => {
        btn.addEventListener("click", function () {
            resolutionBtns.forEach((b) => b.classList.remove("active"));
            this.classList.add("active");
            currentResolution = this.dataset.resolution;

            // Trigger search when Resolution changes
            checkAndSearch();
        });
    });

    // Search products using Predictive Search API (same as header)
    async function searchProducts(query) {
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=20&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag`;

        try {
            const response = await fetch(url);
            const data = await response.json();
            return data.resources?.results?.products || [];
        } catch (error) {
            console.error("Predictive search error:", error);
            return [];
        }
    }

    // Perform search
    async function performSearch() {
        if (!currentCPU || !currentGPU) return;

        // Show loading
        noSelection.style.display = "none";
        noResults.style.display = "none";
        productsGrid.innerHTML = "";
        loadingState.style.display = "block";

        try {
            // Strategy 1: Search with GPU (most specific identifier)
            let products = await searchProducts(currentGPU);

            console.log("Search query:", currentGPU);
            console.log("Initial results:", products.length);

            // Filter results by CPU
            if (products.length > 0) {
                const cpuLower = currentCPU.toLowerCase();

                // Filter by CPU only
                products = products.filter((product) => {
                    const title = (product.title || "").toLowerCase();
                    const body = (product.body || "").toLowerCase();
                    const tags = (product.tags || []).join(" ").toLowerCase();
                    const text = `${title} ${body} ${tags}`;

                    return text.includes(cpuLower);
                });

                console.log("After filtering:", products.length);
            }

            // Strategy 2: If no results, try searching with CPU
            if (products.length === 0) {
                console.log("Trying CPU search...");
                products = await searchProducts(currentCPU);

                if (products.length > 0) {
                    const gpuLower = currentGPU.toLowerCase();

                    products = products.filter((product) => {
                        const title = (product.title || "").toLowerCase();
                        const body = (product.body || "").toLowerCase();
                        const tags = (product.tags || [])
                            .join(" ")
                            .toLowerCase();
                        const text = `${title} ${body} ${tags}`;

                        return text.includes(gpuLower);
                    });
                }
            }

            // Strategy 3: Fallback to products.json
            if (products.length === 0) {
                console.log("Falling back to products.json...");
                const allProductsResponse = await fetch(
                    "/products.json?limit=250",
                );
                const allProductsData = await allProductsResponse.json();

                const cpuLower = currentCPU.toLowerCase();
                const gpuLower = currentGPU.toLowerCase();

                products = (allProductsData.products || []).filter(
                    (product) => {
                        const title = (product.title || "").toLowerCase();
                        const body = (product.body_html || "").toLowerCase();
                        const tags = (product.tags || [])
                            .join(" ")
                            .toLowerCase();
                        const text = `${title} ${body} ${tags}`;

                        return (
                            text.includes(cpuLower) && text.includes(gpuLower)
                        );
                    },
                );
            }

            loadingState.style.display = "none";

            console.log("Final results:", products.length);

            if (products.length === 0) {
                noResults.style.display = "block";
                return;
            }

            // Render products
            renderProducts(products, currentCPU, currentGPU);
        } catch (error) {
            console.error("Search error:", error);
            loadingState.style.display = "none";
            noResults.style.display = "block";
        }
    }

    function renderProducts(products, cpu, gpu) {
        productsGrid.innerHTML = products
            .map((product) => {
                // Handle different response formats (predictive search vs products.json)
                const image =
                    product.featured_image?.url ||
                    product.featured_image ||
                    product.images?.[0]?.src ||
                    "https://via.placeholder.com/400x300?text=No+Image";

                let price = "Contact";
                if (product.price) {
                    // Predictive search returns price in cents
                    price = formatMoney(
                        typeof product.price === "number"
                            ? product.price
                            : parseFloat(product.price) * 100,
                    );
                } else if (product.variants?.[0]?.price) {
                    price = formatMoney(
                        parseFloat(product.variants[0].price) * 100,
                    );
                }

                let comparePrice = null;
                if (product.compare_at_price) {
                    comparePrice = formatMoney(
                        typeof product.compare_at_price === "number"
                            ? product.compare_at_price
                            : parseFloat(product.compare_at_price) * 100,
                    );
                } else if (product.variants?.[0]?.compare_at_price) {
                    comparePrice = formatMoney(
                        parseFloat(product.variants[0].compare_at_price) * 100,
                    );
                }

                const url = product.url || `/products/${product.handle}`;

                return `
        <div class="product-card" data-cpu="${cpu}" data-gpu="${gpu}">
          <div class="product-image">
            <img src="${image}" alt="${product.title}" loading="lazy">
          </div>
          <div class="product-info">
            <h3 class="product-title">${product.title}</h3>
            <div class="product-price">
              ${price}
              ${comparePrice ? `<span class="compare-price">${comparePrice}</span>` : ""}
            </div>
            <a href="${url}" class="view-product-btn">View Details</a>
          </div>
        </div>
      `;
            })
            .join("");
    }

    function formatMoney(cents) {
        const amount = cents / 100;
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        }).format(amount);
    }

    // Get game image from config
    function getGameImage(gameName) {
        const config = window.gameConfig || [];
        const game = config.find(
            (g) => g.name.toLowerCase() === gameName.toLowerCase(),
        );
        return game?.image || null;
    }

    // Render game cards from metafield data
    function renderGameCards(games, productTitle, animate = true) {
        // Check if games are same as current (just update FPS)
        const gameNames = games.map((g) => g.name).join(",");
        const currentNames = currentGames.map((g) => g.name).join(",");

        if (gameNames === currentNames && currentGames.length > 0) {
            // Same games, just update FPS values
            games.forEach((game, index) => {
                const card = gameInfoGrid.children[index];
                if (card) {
                    const fpsEl = card.querySelector(".fps-value");
                    if (fpsEl && fpsEl.textContent !== `${game.fps} FPS`) {
                        if (animate) {
                            fpsEl.classList.add("updating");
                            setTimeout(() => {
                                fpsEl.textContent = `${game.fps} FPS`;
                                fpsEl.classList.remove("updating");
                                fpsEl.classList.add("updated");
                                setTimeout(
                                    () => fpsEl.classList.remove("updated"),
                                    400,
                                );
                            }, 150);
                        } else {
                            fpsEl.textContent = `${game.fps} FPS`;
                        }
                    }
                }
            });
        } else {
            // Different games, rebuild cards with fade animation
            if (animate && gameInfoGrid.children.length > 0) {
                gameInfoGrid.style.opacity = "0.5";
                gameInfoGrid.style.transform = "scale(0.98)";
            }

            setTimeout(
                () => {
                    gameInfoGrid.innerHTML = games
                        .map((game) => {
                            const gameImage = getGameImage(game.name);

                            return `
            <div class="game-info-card" data-game="${game.name}">
              ${
                  gameImage
                      ? `
                <div class="game-image">
                  <img src="${gameImage}" alt="${game.name}" loading="lazy">
                </div>
              `
                      : `
                <h3 class="game-title">${game.name}</h3>
              `
              }
              <div class="fps-value">${game.fps} FPS</div>
              <p class="fps-label">ESTIMATED AVG FPS</p>
            </div>
          `;
                        })
                        .join("");

                    gameInfoGrid.style.opacity = "1";
                    gameInfoGrid.style.transform = "scale(1)";

                    currentGames = games;
                },
                animate ? 150 : 0,
            );
        }
    }

    // Fetch game FPS from current product metafields
    async function fetchGameFPS() {
        if (!currentCPU || !currentGPU) return;

        try {
            // Use current product directly instead of searching
            if (!window.currentProduct || !window.currentProduct.handle) {
                console.log("No current product found");

                if (currentGames.length > 0) {
                    const resetGames = currentGames.map((g) => ({
                        name: g.name,
                        fps: "--",
                    }));
                    renderGameCards(resetGames, null, true);
                }
                return;
            }

            const currentProductHandle = window.currentProduct.handle;
            const gameData = window.productGameData?.[currentProductHandle];

            console.log("Using current product:", currentProductHandle);
            console.log("Game data for current product:", gameData);

            if (!gameData || !gameData.games || gameData.games.length === 0) {
                if (currentGames.length > 0) {
                    const resetGames = currentGames.map((g) => ({
                        name: g.name,
                        fps: "--",
                    }));
                    renderGameCards(resetGames, null, true);
                }
                return;
            }

            // Parse games from metafield (format: "RESOLUTION:GAMENAME:FPS")
            // gameData.games can be a string or array
            let gamesArray = gameData.games;
            if (typeof gamesArray === "string") {
                // If it's a string, try to split by common delimiters
                gamesArray = gamesArray
                    .split(/[•,\n]/)
                    .map((s) => s.trim())
                    .filter((s) => s);
            }
            if (!Array.isArray(gamesArray)) {
                gamesArray = [];
            }

            const selectedRes = currentResolution.toUpperCase();

            // Parse each entry: RESOLUTION:GAMENAME:FPS
            const gameFpsMap = {}; // Map to store game name -> FPS for selected resolution

            gamesArray.forEach((entry) => {
                if (typeof entry !== "string") return;

                const parts = entry.trim().split(":");
                if (parts.length >= 3) {
                    const res = (parts[0] || "").trim().toUpperCase();
                    const gameName = (parts[1] || "").trim();
                    const fps = (parts[2] || "").trim();

                    // Only include entries matching selected resolution
                    if (res === selectedRes && gameName) {
                        gameFpsMap[gameName] = fps || "--";
                    }
                }
            });

            // Convert map to array for rendering
            const games = Object.keys(gameFpsMap).map((gameName) => ({
                name: gameName,
                fps: gameFpsMap[gameName],
            }));

            if (games.length === 0) {
                if (currentGames.length > 0) {
                    const resetGames = currentGames.map((g) => ({
                        name: g.name,
                        fps: "--",
                    }));
                    renderGameCards(resetGames, null, true);
                }
                return;
            }

            // Render game cards
            renderGameCards(
                games,
                window.currentProduct.title || gameData.title,
                true,
            );
        } catch (error) {
            console.error("Error fetching FPS:", error);
        }
    }
});
